import { render } from "./itembar.vue?vue&type=template&id=ec174f78&scoped=true"
import script from "./itembar.vue?vue&type=script&lang=js"
export * from "./itembar.vue?vue&type=script&lang=js"

import "./itembar.vue?vue&type=style&index=0&id=ec174f78&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec174f78"]])

export default __exports__